import React, { Component } from "react";
import { shareFacebook, shareWhatsapp, openNegishut } from "../Services/Sharing"
import "./Header.scss"
import { goToAnchor } from 'react-scrollable-anchor'

export default class Header extends Component {
  constructor() {
    super()
    this.state = {
      isShareActive: false,
      currentTab: -1
    }
    this.activateSharer = this.activateSharer.bind(this);
  }
  activateSharer() {
    this.setState({
      isShareActive: !this.state.isShareActive
    })
  }
  render() {
    return (
      <header>
        <div id="header">
          <div className="padding">
            <div className="container">
              <div className="publisher">
                <a href="" title="" target="_self">
                  <div className="logo"></div>
                </a>
              </div>
              <div className="utils">
                <div className={`share${(this.state.isShareActive ? " active " : "")}`}>
                  <div onClick={shareWhatsapp} className="whatsapp"></div>
                  <div onClick={shareFacebook} className="facebook"></div>
                  <div onClick={this.activateSharer} className="sharer"></div>
                  <div onClick={openNegishut} className="negishut"></div>
                </div>
              </div>
            </div>
          </div>
          <menu>
            <ul>
              {(() => {
                const data = [
                  //   {
                  //   name: "מפלגות",
                  //   link: "",
                  //   fn: () => goToAnchor("section1")
                  // },
                  //  {
                  //   name: "סקרים",
                  //   link: "",
                  //   fn: () => goToAnchor("section2")
                  // },
                  // {
                  //   name: "פרשנויות",
                  //   link: "https://www.ynet.co.il/home/0,7340,L-13547,00.html",
                  //   fn: null
                  // }
                  // {
                  //   name: "מפת הבחירות",
                  //   link: "",
                  //   fn: () => goToAnchor("section3")
                  // },
                  // {
                  //   name: "דקה אחר דקה",
                  //   link: "",
                  //   fn: () => goToAnchor("section4")
                  // },
                  //  {
                  //   name: "סופרים קולות",
                  //   link: "https://www.ynet.co.il/home/0,7340,L-26712,00.html",
                  //   fn: null
                  // }, 
                  // {
                  //   name: "משחק הכיסאות",
                  //   link: "https://z.ynet.co.il/short/content/electionchairs/",
                  //   fn: null
                  // },
                  // {
                  //   name: "סיפורי בחירות",
                  //   link: "https://electionsstories.ynet.co.il/",
                  //   fn: null
                  // },
                  {
                    name: "להבין את הבחירות",
                    link: "https://www.ynet.co.il/articles/0,7340,L-5450114,00.html",
                    fn: null
                  },
                  {
                    name: "איך הצבענו בספטמבר?",
                    link: "http://z.ynet.co.il/short/content/ElectionMap2019/",
                    fn: null
                  }
                ];

                return data.map((item, index) =>
                  <li
                    className={`${index == this.state.currentTab ? "active" : ""}`}
                    key={index}><a
                      onClick={() => {
                        this.setState({
                          currentTab: index
                        })
                        if (item.fn) {
                          item.fn();
                        }
                      }}
                      href={item.link ? item.link : "javascript:void(0)"} title={item.name} target="_self">
                      {item.name}
                    </a></li>)
              })()}
            </ul>
          </menu>
        </div>
      </header>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx